import { render, staticRenderFns } from "./CrewInfo.vue?vue&type=template&id=32db088c&scoped=true&"
import script from "./CrewInfo.vue?vue&type=script&lang=js&"
export * from "./CrewInfo.vue?vue&type=script&lang=js&"
import style0 from "./CrewInfo.vue?vue&type=style&index=0&id=32db088c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db088c",
  null
  
)

export default component.exports